"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var utils_1 = require("../utils");
var LazyLoadContainer = /** @class */ (function (_super) {
    tslib_1.__extends(LazyLoadContainer, _super);
    function LazyLoadContainer(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onWindowScroll = function () {
            _this.handleLazyLoad();
        };
        _this.onWindowResize = function () {
            _this.handleLazyLoad();
        };
        _this.setRef = function (el) {
            _this.$el = el;
        };
        _this.$el = null;
        return _this;
    }
    LazyLoadContainer.prototype.componentDidMount = function () {
        window.addEventListener("scroll", this.onWindowScroll, { passive: true });
        window.addEventListener("resize", this.onWindowResize, { passive: true });
    };
    LazyLoadContainer.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.onWindowScroll, { passive: true });
        window.removeEventListener("resize", this.onWindowResize, { passive: true });
    };
    LazyLoadContainer.prototype.handleLazyLoad = function () {
        var _this = this;
        var _a = this.props, loadMore = _a.loadMore, bottomGap = _a.bottomGap;
        utils_1.raf(function () {
            if (!loadMore || !_this.$el) {
                return;
            }
            var winScrollY = window.scrollY;
            var winInnerHeight = window.innerHeight;
            var tableOffsetHeight = _this.$el.offsetHeight;
            var tableOffsetTop = _this.$el.offsetTop;
            if (winScrollY + winInnerHeight + bottomGap >= (tableOffsetHeight + tableOffsetTop)) {
                loadMore();
            }
        });
    };
    LazyLoadContainer.prototype.render = function () {
        var _a = this.props, children = _a.children, bottomGap = _a.bottomGap, loadMore = _a.loadMore, others = tslib_1.__rest(_a, ["children", "bottomGap", "loadMore"]);
        return (React.createElement("div", tslib_1.__assign({ ref: this.setRef }, others), children));
    };
    LazyLoadContainer.defaultProps = {
        bottomGap: 100,
        loadMore: utils_1.noop
    };
    return LazyLoadContainer;
}(React.Component));
exports.default = LazyLoadContainer;
